export const MAKE_WAREHOUSE_DEFAULT_ACTION="MAKE_WAREHOUSE_DEFAULT_ACTION"
export const DELETE_WAREHOUSE_ACTION="DELETE_WAREHOUSE_ACTION"
export const GET_WAREHOUSE_DETAILS_ACTION="GET_WAREHOUSE_DETAILS_ACTION"
export const EDIT_WAREHOUSE_ACTION="EDIT_WAREHOUSE_ACTION"